import { notesReqApprovalActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [notesReqApprovalActions.loadSuccess]: (state, action) => {
        let result;
        action.payload.entities.notesReqApproval ? result = action.payload.entities.notesReqApproval : result = {};
        return result;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        let result;
        action.payload.notesRequiringApproval.entities.notesReqApproval ? result = action.payload.notesRequiringApproval.entities.notesReqApproval : result = {};
        return result;
    },
    [notesReqApprovalActions.approveAllSuccess]: (state, action) => {
        let result;
        action.payload.entities.notesReqApproval ? result = action.payload.entities.notesReqApproval : result = {};
        return result;
    },
    [notesReqApprovalActions.markReadSuccess]: (state, action) => {
        state[action.payload].isRead = true;
    },
    [notesReqApprovalActions.approveSuccess]: (state, action) => {
        delete state[action.payload];
    },
    [notesReqApprovalActions.rejectSuccess]: (state, action) => {
        delete state[action.payload];
    }

})


